'use client';
import { isRequest } from '../../utils/guards.js';
import { mergeHeaders } from './mergeHeaders.js';
import { requestMethods } from '../../domain/constants.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var normalizeRequestMethod = function(input) {
    return requestMethods.includes(input) ? input.toUpperCase() : input;
};
var defaultMiddlewares = {
    beforeRequest: [],
    beforeError: [],
    afterResponse: []
};
var getInternalOptions = function(input, _param) {
    var middlewares = _param.middlewares, headers = _param.headers, method = _param.method, fetch = _param.fetch, prefixUrl = _param.prefixUrl, options = _object_without_properties_loose(_param, [
        "middlewares",
        "headers",
        "method",
        "fetch",
        "prefixUrl"
    ]);
    var _headers, _method;
    if (isRequest(input)) {
        _method = input.method;
        _headers = input.headers;
    }
    var _ref;
    return _extends({
        credentials: "same-origin",
        timeout: 20000,
        throwHttpErrors: true,
        parseJson: JSON.parse
    }, options, {
        middlewares: _extends({}, defaultMiddlewares, middlewares),
        headers: mergeHeaders(_headers, headers),
        method: normalizeRequestMethod((_ref = method != null ? method : _method) != null ? _ref : "get"),
        fetch: fetch != null ? fetch : globalThis.fetch.bind(globalThis),
        // Сразу приводим URL к строке для дальнейшего использования
        prefixUrl: String(prefixUrl || "")
    });
};

export { getInternalOptions };
